var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProperty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "820.443px",
    height: "595.281px",
    viewBox: "0 0 820.443 595.281",
    enableBackground: "new 0 0 820.443 595.281",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4170",
    transform: "translate(-565.238 -615.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_428",
    opacity: 0.5,
    fill: "#EAF9FA",
    d: "M815.033,631.346c136.695,0,247.517,110.813,247.517,247.517 c0,136.703-110.822,247.517-247.517,247.517c-136.704,0-247.517-110.813-247.517-247.517 C567.517,742.158,678.329,631.346,815.033,631.346z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ecoe_Icons_-02",
    fill: "#0A2240",
    d: "M1293.974,997.057h-100.479V856.968l44.474,43.497l26.256-26.809l-261.56-255.913 l-264.22,261.559l26.288,26.624l45.745-45.375v137.257h-98.949l-86.897,212.623l761.051-1.51L1293.974,997.057z M1002.816,670.436 l153,149.993v272.993h-62.445v-45.375c-0.216-42.717-29.794-79.676-71.434-89.254c30.022-11.346,45.168-44.896,33.812-74.92 c-8.589-22.705-30.359-37.677-54.627-37.569l0,0c-15.451-0.195-30.305,5.973-41.065,17.059 c-22.714,22.541-22.866,59.22-0.336,81.946c0.107,0.107,0.228,0.227,0.336,0.336c5.863,5.711,12.813,10.174,20.437,13.115 c-16.754,3.791-32.098,12.238-44.248,24.379c-17.101,17.252-26.678,40.576-26.634,64.875v46.311h-61.293V824.361L1002.816,670.436z  M1021.567,903.874c0.109,11.28-8.957,20.522-20.238,20.618c-0.13,0.012-0.262,0.012-0.381,0l0,0 c-5.438,0.043-10.651-2.117-14.462-6.004c-3.942-3.832-6.168-9.109-6.179-14.614c0.065-5.462,2.204-10.696,6.005-14.626 c3.887-3.855,9.143-6.015,14.625-6.005l0,0c11.412,0,20.706,9.208,20.804,20.631H1021.567z M737.131,1035.67h74.996v96.006h136.313 v-23.432l0,0v-60.197c0.217-14.105,5.928-27.559,15.938-37.504c9.894-10.076,23.378-15.799,37.504-15.93l0,0 c29.524,0.197,53.497,23.91,53.998,53.434v46.137l0,0v37.502h137.81v-96.951h74.996l58.646,137.061l-648.139,1.324L737.131,1035.67 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/property.40a8e738906ea152960d329d54463438.svg";
export { ForwardRef as ReactComponent };